import {Component, OnInit} from '@angular/core';
import {ChatService} from '../chat.service';
import {BlockModel} from '../../model/block.model';
import {Router} from '@angular/router';
import {first} from "rxjs/operators";
import {QuizService} from '../../service/quiz.service';
import {PreloaderService} from "../../service/preloader.service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './blocks.component.html',
  styleUrls: ['./blocks.component.scss']
})
export class BlocksComponent implements OnInit {
  blocks: BlockModel[];
  backLink = false;

  constructor(
      private quizService: QuizService,
      private preloaderService: PreloaderService,
      private router: Router) {
  }

  ngOnInit() {
      this.quizService.getQuestionSteps().subscribe((data:any) => {
          if(data.status){
              this.setBlocks(data.result);
          }
      });
  }

    setBlocks(blocks: BlockModel[]) {
      this.blocks = blocks;
      // this will remove last two blocks.
      // this.blocks.splice(-2);
      // if(this.blocks[0].progress==80){
      //   this.blocks[0].progress = 100;
      // }
      this.blocks.sort((a, b) => {
        return a.odr - b.odr;
      });
    }

    startQuiz(block) {
      if(!block.hidden){
          this.preloaderService.show();

          let $this = this;
          setTimeout(function () {
              $this.router.navigate(['/chat/' + block.id]);
          },200);
      }
    }

    handleQuizStart() {
        const block = this.blocks[0];

        this.startQuiz(block.id);
    }

    getClass(block){
      if (block.odr !== this.blocks[0].odr) {
        let result = false;

        this.blocks.forEach(bl => {
          if (bl.odr < block.odr) {
            if (bl.progress !== 100 || (bl.end && !block.end)) {
              result = true;
              block.hidden = true;
            }
          }
        });

        if (result) {
          return '--is-disabled';
        }
      }

      if (block.progress !== 100) {
        return '--is-active perc-'+block.progress;
      }

      // if(block.selected){
      //     return '--is-active perc-'+block.progress;
      // }else if(block.hidden){
      //     return '--is-done';
      // }
      // return '';
    }
}
